module.exports = __webpack_public_path__ + "static/media/Background.97858cec.png";